/**
 * <p>****************************************************************************</p >
 * <p><b>Copyright  2013-2019/6/22 soho team All Rights Reserved<b></p >
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2019/6/22</li>
 * <li>@author     : 唐胜</li>
 * </ul>
 * <p>****************************************************************************</p >
 */

import request from '../kernel/request'

export default {
    list(params) {
        return request.get('question', params)
    },
    save(data) {
        return request.post(`question`, data)
    },
    update(data) {
        return request.put(`question`, data)
    },
    delete(id) {
        return request.delete('question/' + id)
    },
    load(id) {
        return request.get('question/' + id)
    },
    getUpdateNode(id) {
        return request.get('question/getUpdateNode/' + id)
    },
    import(params) {
        return request.upload('/question/import', params)
    },
    download: `${request.baseURL}/question/export`
    ,
    paper: {
        list(params) {
            return request.get('paper', params)
        },
        save(data) {
            return request.post(`paper/insert`, data)
        },
        update(data) {
            return request.put(`paper`, data)
        },
        delete(id) {
            return request.delete('paper/' + id)
        },
        load(id) {
            return request.get('paper/' + id)
        },
        saveImport(params) {
            return request.post(`/paper/saveImport`, params)
        },
        removeCache(params) {
            return request.upload(`/paper/removeCache`, params)
        }

    },
    composePaper: {
        list(params) {
            return request.get('compose', params)
        },
        save(data) {
            return request.post(`compose/saveCompose`, data)
        },
        update(data) {
            return request.put(`compose`, data)
        },
        delete(id) {
            return request.delete('compose/' + id)
        },
        load(id) {
            return request.get('paper/' + id)
        },
        addQuestion(params) {
            return request.post('compose/addQuestion', params)
        },
        loadQuestionGroupByType(params) {
            return request.get('compose/groupQuestion', params)
        },
        saveQuestion(params) {
            return request.post('compose/saveQuestion', params)
        },
        loadComposeQuestion(params) {
            return request.get('compose/question', params)
        }
    },
    QuestionBank: {
        list(params) {
            return request.get('/question/bank', params)
        },
        save(data) {
            return request.post(`/question/bank`, data)
        },
        update(data) {
            return request.put(`/question/bank`, data)
        },
        delete(id) {
            return request.delete('/question/bank/' + id)
        },
        questionList(params) {
            return request.get('/question/bank/info', params)
        },
        loadQuestion(id) {
            return request.get('/question/bank/info/' + id)
        },
        import(params){
            return request.upload(`/question/bank/import`, params)
        },
        composeSave(params){
            return request.jonsPost(`/question/bank/compose/save`, params)
        },
        saveImport(params){
            return request.post(`/question/bank/import/save`, params)
        }
    },
    PaperBank: {
        list(params) {
            return request.get('/paper/bank', params)
        },
        save(data) {
            return request.post(`/paper/bank`, data)
        },
        update(data) {
            return request.put(`/paper/bank`, data)
        },
        delete(id) {
            return request.delete('/paper/bank/' + id)
        },
        queryQuestionByType(types){
            return request.get('/paper/bank/queryType', types)
        },
        paperQuestionSave(params){
            return request.post('/paper/bank/question/save', params)
        }
    }
}
